import React from 'react';
import styled from 'styled-components';
import { cssSpacing, Text } from '@spotify-internal/encore-web';
import { DELAYS, withAnimationContext, fadeInAnimation, TWO_COLUMN_MAX_WIDTH, } from '../../ui';
const QuoteContainer = styled.div `
  padding-top: ${cssSpacing('base')};
`;
const QuoteCharacter = withAnimationContext(styled(Text).attrs({ variant: 'headlineMedium' }) `
    ${fadeInAnimation(DELAYS.SECOND)};
    display: block;
    line-height: 24px;
    padding: 0;
    border: 0;
    margin: 0;

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      line-height: 16px;
    }
  `);
const QuoteBody = withAnimationContext(styled(Text).attrs({
    variant: 'bodyMedium',
}) `
    ${fadeInAnimation(DELAYS.THIRD)};
    margin-bottom: ${cssSpacing('looser-2')};
    font-weight: unset;
    display: block;
    font-size: 24px;
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      font-size: unset;
    }
  `);
const Source = withAnimationContext(styled(Text).attrs({
    variant: 'titleSmall',
}) `
    ${fadeInAnimation(DELAYS.FOURTH)};
    margin-bottom: ${cssSpacing('tighter-2')};
    display: block;
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      font-size: 18px;
    }
  `);
const JobTitle = withAnimationContext(styled(Text).attrs({
    variant: 'marginalBold',
}) `
    ${fadeInAnimation(DELAYS.FIFTH)};
    display: block;
    text-transform: uppercase;
  `);
export const Quote = ({ quote = '', source = '', jobTitle = '', }) => {
    return (React.createElement(QuoteContainer, null,
        React.createElement(QuoteCharacter, null, "\u201C"),
        React.createElement(QuoteBody, null, quote),
        React.createElement(Source, null,
            "\u2014",
            source),
        React.createElement(JobTitle, null, jobTitle)));
};
